import styled from 'styled-components';
import { RalewayFont } from 'constants/fonts';
import { black } from 'constants/colors';

export const AvatarNewWrapper = styled.div`
  width: 100px;
  height: 120px;
  position: relative;
  margin: 10px;
  display: inline-block;

  .bubble {
    margin: 5px;
    position: absolute;
    width: 18px;
    height: 15px;
    right: 0px;
  }

  .champion {
    position: absolute;
    top: 10px;
    left: 5px;
    z-index: 1;
  }

  .new_avatar {
    z-index: 2;
    text-align: center;
    margin-bottom: 1rem;
  }

`;

export const AvatarName = styled.div`
  font-family: ${RalewayFont.regularFamily}
  font-size: 1.2rem;
  text-align: center;
  color: ${black};
`;



// WEBPACK FOOTER //
// ./src/components/AvatarNew/components/styles.js